export function seo({
  title,
  description,
}: {
  title: string
  description?: string
}) {
  const tags = [
    { title: `${title} | First Response` },
    { name: 'description', content: description ?? '' },
  ]
  return tags
}
